import React from 'react';

import { useTranslation } from 'react-i18next';

import { useJournalEventsFiltersContext } from '@features/JournalEventsFilters/lib/useJournalEventsFiltersContext';
import { Icon, UiMultiSelect } from '@shared/ui';

import cls from './FilterByType.module.css';

export const FilterByType = () => {
    const { typesData, onTypeClick, typesDefaultValues, onClearTypesValues } =
        useJournalEventsFiltersContext();
    const { t } = useTranslation();
    return (
        <UiMultiSelect
            options={typesData}
            defaultValues={typesDefaultValues}
            placeholder={t('JournalEvents.Filters.Filter.byType.placeholder')}
            leftIconSlot={<Icon iconName="taskTags" fill="#FF8F28" />}
            arrowIconSlot={<Icon iconName="selectArrow" />}
            clearIconSlot={<Icon iconName="resetInput" />}
            onItemClickCb={onTypeClick}
            onClearValuesCb={onClearTypesValues}
            optionsListClassNames={cls.optionsList}
        />
    );
};
